import { AbstractControlOptions, AsyncValidatorFn, FormControl, ValidatorFn } from '@angular/forms';

export class PortalFormControl<T> extends FormControl {
  constructor(
    // FormControl base class defines parameter as any.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formState: any,
    validatorOrOpts?: ValidatorFn | AbstractControlOptions | ValidatorFn[],
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[],
  ) {
    super(formState, validatorOrOpts, asyncValidator);
  }

  public needsAction(errorKey: string): boolean {
    return this.isInvalid() && this.hasError(errorKey);
  }

  public isInvalid(): boolean {
    return this.invalid && this.touched;
  }
}
